import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import classnames from 'classnames';

/* actions */
import { getList } from '@store/dashboards/list/actions';
import { changeSaveDashboardPromptVisibility } from '@store/dashboards/ui/actions';
import { createDashboard } from '@store/dashboards/create/actions';
import { updateDashboard } from '@store/dashboards/update/actions';

/* selectors */
import { listSelector, listLoaderSelector } from '@store/dashboards/list/selectors';
import { tabsSelector } from '@store/dashboards/tabs/selectors';

import DashboardDropdown from '../../../DashboardNavigator/DashboardDropdown';
import globalStyles from '../index.less';

const selector = createSelector(
  listSelector,
  tabsSelector,
  listLoaderSelector,
  (
    list,
    tabs,
    listLoader,
  ) => ({
    list,
    tabs,
    isFetching: listLoader,
    className: classnames(globalStyles.tab, globalStyles.fixed, globalStyles.dropdown),
  }),
);

export default connect(
  selector,
  {
    getList,
    createDashboard,
    updateDashboard,
    changeSaveDashboardPromptVisibility,
  },
)(DashboardDropdown);
